__turbopack_context__.v({
  "variant": "QuestionSelect-module__b-43Fa__variant",
});
